var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Header'),_c('SideBar'),_c('v-main',[_c('div',{staticClass:"pa-5"},[_c('router-view')],1)]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }